import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import KioskPage from './pages/KioskPage';
import ShortLinkPage from './pages/ShortLinkPage';
import { KioskV2SessionProvider } from './components/form-package-v2/KioskV2SessionContext';
import './styles/index.css';

// Dev-only: click through the v2 form UI with fixture data at /dev/forms, and
// preview the household hub at /dev/household.
const isDev = process.env.NODE_ENV === 'development';
const DevFormHarness = isDev ? React.lazy(() => import('./pages/DevFormHarness')) : null;
const DevHouseholdHarness = isDev ? React.lazy(() => import('./pages/DevHouseholdHarness')) : null;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <KioskV2SessionProvider>
        <Routes>
          {DevFormHarness && (
            <Route
              path="/dev/forms"
              element={
                <React.Suspense fallback={null}>
                  <DevFormHarness />
                </React.Suspense>
              }
            />
          )}
          {DevHouseholdHarness && (
            <Route
              path="/dev/household"
              element={
                <React.Suspense fallback={null}>
                  <DevHouseholdHarness />
                </React.Suspense>
              }
            />
          )}
          <Route path="/f/:shortCode" element={<ShortLinkPage />} />
          <Route path="/kiosk/:slug" element={<KioskPage />} />
          <Route path="/:slug" element={<App />} />
          <Route path="/" element={<App />} />
        </Routes>
      </KioskV2SessionProvider>
    </BrowserRouter>
  </React.StrictMode>
);
